import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind CSS classes without conflicts.
 * Combines clsx (conditional classes) with tailwind-merge (conflict resolution).
 *
 * @example
 * cn('p-2', 'p-4') // → 'p-4'
 * cn('text-red-500', isActive && 'text-green-500') // conditional
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
